import { render, staticRenderFns } from "./TermsProvider.vue?vue&type=template&id=fb36975a"
import script from "./TermsProvider.vue?vue&type=script&lang=js"
export * from "./TermsProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports